<div class="profile-container">
  <div class="profile-card">
    <nz-space>
      <div *nzSpaceItem class="user-image">
        <i class="fas fa-user-tie"></i>
      </div>
      <div *nzSpaceItem class="user-info">
        <h1>{{ userData.name }}</h1>
        <h3>{{ userData.email }}</h3>
        <p>{{ userData.role }}</p>
      </div>
    </nz-space>
    <div class="actions">
      <button
        nz-button
        nzType="primary"
        class="border-radius"
        (click)="resetPasswordRequest()"
      >
        <nz-space>
          <i *nzSpaceItem class="fal fa-key"></i>
          <span *nzSpaceItem>{{'Reset Password' | translate}}</span>
        </nz-space>
      </button>
    </div>
  </div>
</div>
